import { Plus } from '@phosphor-icons/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { AddJob } from 'jobs/components/AddJob';
import { Color } from 'theme/enums';

interface IProps {
  projectId?: number;
  onSubmitSuccess?: () => void;
}

export const AddJobButton = ({ projectId, onSubmitSuccess: customOnSubmitSuccess }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const onSubmitSuccess = () => {
    customOnSubmitSuccess?.();
  };

  return (
    <>
      <Button
        text={t('buttonLabelAddJob')}
        color={Color.SUCCESS}
        startDecorator={<Plus />}
        onClick={() => setIsOpen(true)}
      />

      <AddJob
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSubmitSuccess={onSubmitSuccess}
        projectId={projectId}
      />
    </>
  );
};
